import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { Bars, Circles } from "react-loader-spinner";
import nodata from "../../Assets/Image/admin/nodata.png";
import view from "../../Assets/Image/admin/view.png";
import deletes from "../../Assets/Image/admin/delete.png";
import add from "../../Assets/Image/admin/add.png";
import { useNavigate } from "react-router-dom";
import Dialog from "../../Base-Component/Dialog/Dialog";
import { ChevronDown, ChevronUp, CircleX } from "lucide-react";
import edit from "../../Assets/Image/admin/edit.png";
import toast from "react-hot-toast";
import Cookies from "js-cookie";
import { IMG_URL } from "../../Services/Api";
import noImage from "../../Assets/Image/admin/user.png";
import {
  addOffers,
  deleteOffers,
  getCategoryList,
  getOffersDetails,
  listUserRole,
  updatedOffers,
} from "../../Services/ApiServices";
import "suneditor/dist/css/suneditor.min.css";
import SunEditor from "suneditor-react";
import DOMPurify from "dompurify";
import PropTypes from "prop-types";

function Offers() {
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  const [selectedOption, setSelectedOption] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isModalOpens, setModalOpens] = useState(false);
  const [isAddWeblink, setIsAddWeblink] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpens, setIsOpens] = useState(false);

  const [offerId, setOfferId] = useState("");
  const [isIndex, setIsIndex] = useState("");
  const [descriptionData, setDescriptionData] = useState("");

  const [pageNo, setPageNo] = useState(1);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const [formValue, setFormValue] = useState({});
  const [offersData, setOffersData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [userRoleData, setUserRoleData] = useState([]);
  const [userRoleSelected, setUserRoleSelected] = useState([]);

  const handleCategoryList = () => {
    setLoader(true);
    getCategoryList()
      .then((res) => {
        const data = res.data.data;
        setCategoryData(data);
        const option = data?.map((item) => ({
          label: (
            <div className="flex items-center p-1 uppercase">
              <img
                src={
                  item.category_image ? IMG_URL + item.category_image : noImage
                }
                className="w-14 h-14 rounded-md object-cover mr-2"
              />
              {item.category_name || ""}
            </div>
          ),
          value: item.id,
          id: item.category_name,
        }));

        if (option?.length > 0) {
          setSelectedOption(option[0]);
        }
        setLoader(false);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
        setLoader(false);
      });
  };

  const handleOfferList = (data) => {
    setLoader(true);
    let obj = {
      category_id: data,
    };
    getOffersDetails(obj)
      .then((res) => {
        if (res.data.status == 1) {
          const datas = res.data.data;
          setOffersData(datas);
          setLoader(false);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
        setLoader(false);
      });
  };

  useEffect(() => {
    handleCategoryList();
  }, []);

  useEffect(() => {
    if (selectedOption) {
      handleOfferList(selectedOption.value);
    }
  }, [selectedOption, pageNo]);

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: "50px",
      height: "50px",
      border: "none",
      outline: "0px",
      boxShadow: "none",
      "&:hover": {
        border: "none",
      },
      "&:focus": {
        border: "none",
        boxShadow: "none",
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: "50px",
      padding: "0 8px",
      border: "0px",
      outline: "0px",
    }),
    input: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: "50px",
      border: "0px",
      outline: "0px",
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "white" : "black",
      cursor: "pointer",
      backgroundColor: state.isSelected
        ? "#e29c2995"
        : state.isFocused
        ? "#e29c2940"
        : "white",
      ":active": {
        backgroundColor: "#e29c2910",
        color: "white",
      },
    }),
    singleValue: (provided, state) => {
      const opacity = state.isDisabled ? 0.5 : 1;
      const transition = "opacity 300ms";
      return {
        ...provided,
        opacity,
        transition,
        display: "flex",
        alignItems: "center",
      };
    },
  };

  const startDragging = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
    document.body.style.userSelect = "none";
  };

  const stopDragging = () => {
    setIsDragging(false);
    document.body.style.userSelect = "";
  };

  const onDragging = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (isUpdate) {
      let obj = {
        title: formValue.title,
        description: descriptionData,
        category_id: selectedOptions.toString(),
        reward_points: formValue.reward_points,
        offer_id: formValue.id,
        role_id: userRoleSelected.toString(),
      };
      if (!descriptionData) {
        toast.error("Please enter description");
        setIsLoading(false);
      } else if (selectedOptions.length === 0) {
        toast.error("Please select user role");
        setIsLoading(false);
      } else {
        updatedOffers(obj)
          .then((res) => {
            toast.success(res.data.message);
            setIsAddWeblink(false);
            handleOfferList(selectedOption.value);
          })
          .catch((err) => {
            if (err?.response?.status == 401) {
              Cookies.remove("e_learning_token");
              navigate("/login");
            } else {
              toast.error(err?.response?.data?.message);
            }
            setIsLoading(false);
          });
      }
    } else {
      let obj = {
        title: formValue.title,
        description: descriptionData,
        category_id: selectedOptions.toString(),
        role_id: userRoleSelected.toString(),
        reward_points: formValue.reward_points,
      };

      if (!descriptionData) {
        toast.error("Please enter description");
        setIsLoading(false);
      } else if (selectedOptions.length === 0) {
        toast.error("Please select category");
        setIsLoading(false);
      } else {
        addOffers(obj)
          .then((res) => {
            toast.success(res.data.message);
            setIsAddWeblink(false);
            handleOfferList(selectedOption.value);
          })
          .catch((err) => {
            if (err?.response?.status == 401) {
              Cookies.remove("e_learning_token");
              navigate("/login");
            } else {
              toast.error(err?.response?.data?.message);
            }
            setIsLoading(false);
          });
      }
    }
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setIsLoading(true);

    let obj = {
      offer_id: offerId,
    };
    deleteOffers(obj)
      .then((res) => {
        toast.success(res.data.message);
        setIsDelete(false);
        const data = [...offersData];
        data.splice(isIndex, 1);
        setOffersData(data);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else if (err?.response?.status == 422) {
          const errs = err?.response?.data;
          toast.error(errs?.errors[0]?.msg);
        } else {
          toast.error(err?.response?.data?.message);
        }
        setIsLoading(false);
      });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleEdit = (data) => {
    setIsUpdate(true);
    setFormValue(data);
    setDescriptionData(data.description);
    setIsAddWeblink(true);
    setIsLoading(false);
    setIsOpen(false);
    setSelectedOptions([data.category_id]);
    // Clear existing role selections first, then add current offer's roles
    setUserRoleSelected([]);
    for (let i = 0; i < data.offerRoles.length; i++) {
      const main = data.offerRoles[i].role_id;
      setUserRoleSelected((pre) => [...pre, main]);
    }
    handleUserRoleList();
  };

  const HtmlContent = ({ htmlString }) => {
    const sanitizedHtml = DOMPurify.sanitize(htmlString);
    const style = `
      ol {
        margin: 0;
        padding: 0;
        list-style-type: decimal; /* Numbering */
        padding-left: 20px; /* Adjust left padding as needed */
      }
      ul {
        margin: 0;
        padding: 0;
        list-style-type: disc; /* Bullets */
        padding-left: 20px; /* Adjust left padding as needed */
      }
      li {
        margin: 0;
        padding: 0;
        line-height: 1.5;
      }
      a {
        color: blue;
      }
    `;

    return (
      <div
        dangerouslySetInnerHTML={{
          __html: `<style>${style}</style>${sanitizedHtml}`,
        }}
      />
    );
  };

  HtmlContent.propTypes = {
    htmlString: PropTypes.string.isRequired,
  };

  const handleView = () => {
    setIsAddWeblink(true);
    setFormValue({});
    setIsLoading(false);
    setDescriptionData("");
    setIsUpdate(false);
    setIsOpen(false);
    setSelectedOptions([]);
    setUserRoleSelected([]);
    handleUserRoleList();
  };

  const handleDeleteView = (id, index) => {
    setIsDelete(true);
    setOfferId(id);
    setIsIndex(index);
    setIsLoading(false);
  };

  const toggleDropdown = () => {
    if (!isOpen) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  };

  const toggleDropdowns = () => {
    if (!isOpens) {
      setIsOpens(true);
    } else {
      setIsOpens(false);
    }
  };

  const handleCheckboxChange = (option) => {
    setSelectedOptions((prevSelected) =>
      prevSelected.includes(option)
        ? prevSelected.filter((item) => item !== option)
        : [...prevSelected, option]
    );
  };

  const handleCheckboxChanges = (option) => {
    setUserRoleSelected((prevSelected) =>
      prevSelected.includes(option)
        ? prevSelected.filter((item) => item !== option)
        : [...prevSelected, option]
    );
  };

  const handleSelectAllRoles = (e) => {
    if (e.target.checked) {
      const allIds = userRoleData.map((item) => item.id);
      setUserRoleSelected(allIds);
    } else {
      setUserRoleSelected([]);
    }
  };

  const handleMove = (id) => {
    navigate("/offer-user/" + id);
  };

  const handleUserRoleList = () => {
    listUserRole()
      .then((res) => {
        const data = res.data.data;
        setUserRoleData(data);
      })
      .catch((err) => {
        if (err.response.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
      });
  };

  return (
    <div className="md:m-4 m-1 fontNew">
      <div className="flex sm:flex-nowrap flex-wrap justify-end mb-7">
        <div className="sm:w-auto w-full">
          <div>
            <button
              onClick={handleView}
              className="bg-[#e29c29] text-white flex items-center py-2 px-3 sm:mb-0 mb-3 rounded-lg whitespace-nowrap"
            >
              <img src={add} className="w-6 mr-2" alt="" />
              Add Offer
            </button>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-6 mb-5">
        <div className="lg:col-span-6 col-span-12">
          <Select
            value={selectedOption}
            onChange={(option) => {
              setSelectedOption(option);
              setPageNo(1);
            }}
            options={categoryData?.map((item) => ({
              label: (
                <div className="flex items-center p-1 uppercase">
                  <img
                    src={
                      item.category_image
                        ? IMG_URL + item.category_image
                        : noImage
                    }
                    className="w-14 h-14 rounded-md object-cover mr-2"
                  />
                  {item.category_name || ""}
                </div>
              ),
              value: item.id,
              id: item.category_name,
            }))}
            placeholder="Select Category"
            className="bg-white py-2 outline-0 rounded-lg"
            styles={customStyles}
          />
        </div>
      </div>

      <div className="grid grid-cols-12">
        {loader ? (
          <div className="flex justify-center items-center col-span-12 h-[70vh]">
            <Bars
              height="35"
              width="35"
              color="#e29c29"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        ) : (
          <>
            {offersData.length == 0 ? (
              <div className="col-span-12 h-[50vh] justify-center flex items-center">
                <img src={nodata} className="w-28" alt="No data" />
              </div>
            ) : (
              <div className="col-span-12">
                <div
                  className="w-full lg:overflow-hidden overflow-auto"
                  onMouseDown={startDragging}
                  onMouseLeave={stopDragging}
                  onMouseUp={stopDragging}
                  onMouseMove={onDragging}
                  ref={scrollRef}
                >
                  <table className="w-full border-separate border-spacing-y-3">
                    <thead>
                      <tr className="bg-white">
                        <th className="py-4 px-7 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                          <h4>OFFER ID</h4>
                        </th>
                        <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                          <h4>TITLE</h4>
                        </th>
                        <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                          <h4>DESCRIPTION</h4>
                        </th>
                        <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                          <h4>REWARD POINT</h4>
                        </th>
                        <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                          <h4>USE USER</h4>
                        </th>
                        <th className="py-4 px-2 text-base font-medium whitespace-nowrap text-start first:rounded-l-lg last:rounded-r-lg">
                          <div className="text-center">
                            <h4>ACTION</h4>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {offersData.map((item, index) => (
                        <tr key={index} className="font-medium bg-white">
                          <td className="text-start px-7 py-3 first:rounded-l-lg last:rounded-r-lg">
                            <div className="whitespace-nowrap">
                              {item.id || "-"}
                            </div>
                          </td>
                          <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                            <div className="whitespace-nowrap">
                              <p className="text-base truncate w-[250px]">
                                {item.title || "-"}
                              </p>
                            </div>
                          </td>
                          <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                            <div className="whitespace-nowrap">
                              <p className="text-base truncate w-[300px] h-[45px]">
                                <HtmlContent
                                  htmlString={item.description || "-"}
                                />
                              </p>
                            </div>
                          </td>
                          <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                            <div className="whitespace-nowrap">
                              <p className="text-base truncate w-[250px]">
                                {item.reward_points || "-"}
                              </p>
                            </div>
                          </td>
                          <td className="text-start lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                            <div className="whitespace-nowrap">
                              <button
                                className="bg-[#e6f5f2] px-3 py-2 rounded-xl "
                                onClick={(e) => handleMove(item.id)}
                              >
                                {item.reword_histories.length || ""} View User
                              </button>
                            </div>
                          </td>
                          <td className="text-start flex justify-center lg:px-2 px-4 py-3 first:rounded-l-lg last:rounded-r-lg">
                            <div className="flex items-center w-52 justify-center">
                              <div
                                onClick={(e) => {
                                  setModalOpens(true);
                                  setFormValue(item);
                                  setIsLoading(false);
                                }}
                                className="cursor-pointer"
                              >
                                <img
                                  src={view}
                                  className="lg:w-9 w-8"
                                  alt="View"
                                />
                              </div>
                              <div
                                onClick={(e) =>
                                  handleDeleteView(item.id, index)
                                }
                                className="ml-4 cursor-pointer"
                              >
                                <img
                                  src={deletes}
                                  className="lg:w-9 w-8"
                                  alt="Delete"
                                />
                              </div>
                              <div
                                className="ml-4 cursor-pointer"
                                onClick={() => handleEdit(item)}
                              >
                                <img
                                  src={edit}
                                  className="lg:w-9 w-8"
                                  alt="Delete"
                                />
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      <Dialog
        open={isAddWeblink}
        onClose={() => setIsAddWeblink(false)}
        size="xl"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="p-4 sm:w-auto w-[330px] md:h-[700px] h-[500px] overflow-auto fontNew">
              <h4 className="text-lg font-semibold mb-2">
                {isUpdate ? "Update" : "Add"} Offer
              </h4>
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-12 ">
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">
                      Select Category
                    </h4>
                    <div className="multi-select-dropdown bg-white rounded px-4 py-3 border-2 w-full outline-2 outline-[#ead5fd]">
                      <div
                        className="flex justify-between cursor-pointer"
                        onClick={toggleDropdown}
                      >
                        <span>{"Select Multiple Category"}</span>
                        <button type="button">
                          {isOpen ? (
                            <ChevronUp className="text-[#000000]" />
                          ) : (
                            <ChevronDown className="text-[#000000]" />
                          )}
                        </button>
                      </div>

                      {isOpen && (
                        <div className="dropdown-menu w-full rounded-lg">
                          {categoryData.map((item, index) => (
                            <label
                              key={index}
                              className="flex items-center space-x-2"
                            >
                              <input
                                type="checkbox"
                                className="absolute right-0 setOptionCheckbox"
                                checked={selectedOptions.includes(item.id)}
                                onChange={() => handleCheckboxChange(item.id)}
                              />
                              {item.category_name}
                            </label>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">Offer Title</h4>
                    <input
                      type="text"
                      name="title"
                      required
                      value={formValue.title || ""}
                      onChange={handleChange}
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">
                      Offer Reward Point
                    </h4>
                    <input
                      type="number"
                      name="reward_points"
                      required
                      value={formValue.reward_points || ""}
                      onChange={handleChange}
                      min={0}
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">
                      Select User Role
                    </h4>
                    <div className="multi-select-dropdown bg-white rounded px-4 py-3 border-2 w-full outline-2 outline-[#ead5fd]">
                      <div
                        className="flex justify-between cursor-pointer"
                        onClick={toggleDropdowns}
                      >
                        <span>{"Select Multiple User Role"}</span>
                        <button type="button">
                          {isOpens ? (
                            <ChevronUp className="text-[#000000]" />
                          ) : (
                            <ChevronDown className="text-[#000000]" />
                          )}
                        </button>
                      </div>

                      {isOpens && (
                        <div className="dropdown-menu w-full rounded-lg">
                          <label className="flex items-center space-x-2 border-b pb-2 mb-2">
                            <input
                              type="checkbox"
                              className="absolute right-0 setOptionCheckbox"
                              checked={
                                userRoleSelected.length ===
                                  userRoleData.length && userRoleData.length > 0
                              }
                              onChange={handleSelectAllRoles}
                            />
                            Select All
                          </label>
                          {userRoleData.map((item, index) => (
                            <label
                              key={index}
                              className="flex items-center space-x-2"
                            >
                              <input
                                type="checkbox"
                                className="absolute right-0 setOptionCheckbox"
                                checked={userRoleSelected.includes(item.id)}
                                onChange={() => handleCheckboxChanges(item.id)}
                              />
                              {item.role_name}
                            </label>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">
                      Offer Description
                    </h4>
                    <SunEditor
                      setContents={descriptionData || ""}
                      onChange={setDescriptionData}
                      height="280px"
                      setOptions={{
                        buttonList: [
                          ["undo", "redo"],
                          ["fontSize"],
                          ["bold", "underline", "italic"],
                          ["fontColor", "hiliteColor"],
                          ["align", "list"],
                          ["link", "image"],
                        ],
                      }}
                      name="my-editor"
                      required
                    />
                  </div>
                </div>
                <div className="mt-6 flex justify-end">
                  <button
                    type="button"
                    onClick={() => setIsAddWeblink(false)}
                    className="bg-[#EF5F5F] py-2 px-7 text-white rounded-lg mr-5"
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    disabled={isLoading}
                    className="bg-[#00987C] text-white h-[45px] w-30 rounded-lg"
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      `${isUpdate ? "Update" : "Add"}`
                    )}
                  </button>
                </div>
              </form>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={isModalOpens}
        onClose={() => setModalOpens(false)}
        size="md"
      >
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="sm:w-auto w-[330px] h-[500px] overflow-auto fontNew">
              <div className="flex justify-between border-b p-5">
                <h4 className="text-lg font-medium">Offer Details</h4>
                <CircleX
                  color="gray"
                  size={28}
                  onClick={() => setModalOpens(false)}
                  className="cursor-pointer"
                />
              </div>
              <div className="p-5">
                <div>
                  <p>Title :</p>
                  <h3 className="text-lg font-medium break-words">
                    {formValue.title || ""}
                  </h3>
                </div>
                <div className="my-3">
                  <p>Reward Point :</p>
                  <h3 className="text-lg font-medium break-words">
                    {formValue.reward_points || ""}
                  </h3>
                </div>
                <div>
                  <p>Description :</p>
                  <p>
                    <HtmlContent htmlString={formValue.description || ""} />
                  </p>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog open={isDelete} onClose={() => setIsDelete(false)} size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="flex justify-center text-center my-4 sm:px-16 px-4 fontNew">
              <div>
                <h4 className="text-xl font-semibold text-black mt-6">
                  Delete Offer?
                </h4>
                <p className="text-sm text-gray-500 my-3">
                  Are you sure you want to delete this Offer?
                </p>
                <div className="mt-13 flex items-center mb-5">
                  <button
                    className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                    onClick={() => setIsDelete(false)}
                  >
                    Close
                  </button>
                  <button
                    disabled={isLoading}
                    className="bg-[#e29c29] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                    onClick={handleDelete}
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      "Yes, Delete"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>
    </div>
  );
}

export default Offers;
